import React from 'react';
import { Star } from 'lucide-react';

export const StarRating = ({ value = 0, size = 16, className = '' }) => {
  return (
    <div className={`inline-flex items-center gap-0.5 ${className}`} aria-label={`${value} de 5 estrellas`}>
      {[1, 2, 3, 4, 5].map((n) => (
        <Star
          key={n}
          className={n <= value ? 'text-orange-400 fill-orange-400' : 'text-white/15'}
          style={{ width: size, height: size }}
          strokeWidth={1.5}
        />
      ))}
    </div>
  );
};

export const StarPicker = ({ value = 0, onChange, size = 32 }) => {
  const [hover, setHover] = React.useState(0);
  const active = hover || value;
  return (
    <div className="inline-flex items-center gap-1.5" role="radiogroup" aria-label="Calificación">
      {[1, 2, 3, 4, 5].map((n) => (
        <button
          type="button"
          key={n}
          onMouseEnter={() => setHover(n)}
          onMouseLeave={() => setHover(0)}
          onClick={() => onChange && onChange(n)}
          data-testid={`star-${n}-btn`}
          className="transition-transform hover:scale-110 active:scale-95"
          aria-checked={value === n}
          role="radio"
        >
          <Star
            className={n <= active ? 'text-orange-400 fill-orange-400 drop-shadow-[0_0_8px_rgba(249,115,22,0.5)]' : 'text-white/20 hover:text-white/40'}
            style={{ width: size, height: size }}
            strokeWidth={1.5}
          />
        </button>
      ))}
    </div>
  );
};

export default StarRating;
